import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs } from "../../Components/Block"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataSail } from "../../Types"

interface ShipDataSailViewProps {
  data: IShipDataSail;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeSail: () => void;
}

export function ShipDataSailView({ data, editable, index, onEdited, removeSail }: ShipDataSailViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `sails[${index}].`;

  { /* List for sails */ }
  // Initialize sail with the value from data, or undefined if not present
  const [sail, setSail] = useState<string | undefined>(data.sail);
  const predefinedSails = ["mainsail", "genoa", "jib", "working_jib", "strom_jib", "spinnaker", "gennaker", "code0", "parasailor", "mizzen", "mizzen_staysail", "try"];
  const selectSail = useCallback((value?: string) => {
    setSail(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  { /* List for sailTypes */ }
  // Initialize sailType with the value from data, or undefined if not present
  const [sailType, setSailType] = useState<string | undefined>(data.sailType);
  const predefinedTypes = ["forestay", "mast", "mizzen"];
  const selectSailType = useCallback((value?: string) => {
    setSailType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  const [reefNo, setReefNo] = useState<number>(data.reefNo || 0);
  const predefinedReefNos = [0, 1, 2, 3];

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="block-row-wrap" onRemove={removeSail}>
      <BlockField label={t("sail")} className="block_field_small_14">
        <PredefinedSelect value={sail} predefined={predefinedSails} label={(v) => t(`sail_${v}`)} customValue={t("other")} name={`${namePrefix}sail`} onSelect={selectSail} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("sail_type")} className="block_field_small_12">
        <PredefinedSelect value={sailType} predefined={predefinedTypes} label={(v) => t(`sail_${v}`)} customValue={t("other")} name={`${namePrefix}sailType`} onSelect={selectSailType} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("sail_reefs_no")} className="block_field_small_8">
        <select className="ShipTypeSelect" name={`${namePrefix}reefNo`} value={reefNo} onChange={(e) => { setReefNo(parseInt(e.target.value)); if (onEdited) { onEdited(); } }} disabled={!editable}>
          {predefinedReefNos.map((type) => (
            <option value={type} key={`reef_${type}`}>{t(`sail_${type}`)}</option>
          ))}
        </select>
      </BlockField>

      <BlockField label={t("sail_size")} className="block_field_small_8">
        <BlockFieldInputs><input className="unit" name={`${namePrefix}size`} defaultValue={data.size} onChange={onEdited} readOnly={!editable} />
          <UnitSelect kind="surface" name={`${namePrefix}sizeUnit`} value={data.sizeUnit} editable={editable} onChange={onEdited} />
        </BlockFieldInputs>
      </BlockField>
      {/* </BlockRow>

    <BlockRow className="block-row-last"> */}
      <BlockField label={t("manufacturer")} className="block_field_small_14">
        <input name={`${namePrefix}manufacturer`} defaultValue={data.manufacturer} onChange={onEdited}readOnly={!editable} />
      </BlockField>

      <BlockField label={t("comment")} className="block_field_small_30">
        <input name={`${namePrefix}comment`} defaultValue={data.comment} onChange={onEdited} readOnly={!editable} />
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
